package meineglasfaser.frontend.www.pages.explore

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.RouteInfo
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.http.*
import meineglasfaser.api.routes.ShopRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.rememberQuery
import org.jetbrains.compose.web.dom.*

internal fun RouteInfo.categoryBy(name: String) = let {
    params.getValue(name)
}

@Page("{audience}/{category}")
@Layout(".components.layouts.ShopLayout")
@Composable
fun CategoryPage(ctx: PageContext) {
    val customerType = ctx.route.customerTypeBy("audience")
    val category = ctx.route.categoryBy("category")

    val data = rememberQuery<ShopRoutes.Query.Networks.ResponseBody?>(null, ctx.route) {
        BackendApi.get(ShopRoutes.Query.Networks(customerType, category))
    }

    data?.let { data ->
        Div {
            H1 { Text(data.category.title) }
            P { Text(data.category.summary) }
            P { Text(data.category.details) }
            Div({ classes("row-fluid") }) {
                data.networks.forEach { network ->
                    Div({ classes("col-12", "col-lg-6") }) {
                        Article {
                            Header {
                                B { Text(network.title) }
                            }
                            Div(attrs = { classes("flex-column") }) {
                                Span { Text(network.summary) }
                            }
                            val url = URLBuilder().takeFrom(ctx.route.path).run {
                                appendPathSegments(network.id)
                                encodedPath
                            }
                            Anchor(href = url, attrs = { role("button") }) {
                                Text("Zu den Produkten")
                            }
                        }
                    }
                }
            }
        }
    }
}
